// insuranceUrlState — minimal URL helpers used by the cross-tab
// navigation contract on the Details surface to deep-link into the
// Insurance tab with a status filter pre-applied. Mirrors the shape of
// the deliverable / milestone URL-state helpers but exposes only the
// status filter that the cross-tab summary card needs.

export type InsuranceStatusFilter = "expiring";

export interface InsuranceUrlFilters {
  status?: InsuranceStatusFilter;
}

const STATUS_KEY = "filters[status]";

const ALLOWED_STATUS: ReadonlySet<InsuranceStatusFilter> = new Set(["expiring"]);

export function readInsuranceFiltersFromUrl(
  searchParams: URLSearchParams,
): InsuranceUrlFilters {
  const raw = searchParams.get(STATUS_KEY);
  if (!raw) return {};
  const trimmed = raw.trim();
  if (!trimmed) return {};
  if (!(ALLOWED_STATUS as Set<string>).has(trimmed)) return {};
  return { status: trimmed as InsuranceStatusFilter };
}

export function writeInsuranceFiltersToUrl(
  base: URLSearchParams,
  filters: InsuranceUrlFilters,
): URLSearchParams {
  const next = new URLSearchParams(base.toString());
  next.delete(STATUS_KEY);
  if (filters.status) {
    next.set(STATUS_KEY, filters.status);
  }
  return next;
}

export function buildInsuranceUrl(
  contractId: string,
  filters: InsuranceUrlFilters,
): string {
  const params = new URLSearchParams();
  params.set("tab", "insurance");
  if (filters.status) {
    params.set(STATUS_KEY, filters.status);
  }
  return `/manage/contracts/${contractId}?${params.toString()}`;
}
